import React from "react";
import * as R from "ramda";
import { connect } from "react-redux";

import { Link } from "react-router";

import { eventDetails } from "redux/modules/event/selectors";
import { getValue } from "../../utils";

const decorate = connect((state, props) => ({
  eventDetails: eventDetails(state, props)
}));

const UserTagCount = props => {
  const value = getValue(props);

  const style = {
    cursor: "pointer",
    width: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    color: "#1E62D8"
  };

  if (R.isNil(value) || value === 0) {
    return (
      <div style={style} className="underline-on-hover">
        {value}
      </div>
    );
  }
  const { eventDetails = {}, data = {} } = props || {};
  const { id: eventId = null } = eventDetails;
  const pathname = `/event-light/${eventId}/team`;
  const { id: tagId = null, data: dataObj = {} } = data;
  const { name } = dataObj;

  return (
    <Link
      to={{ pathname, query: { tagId, tagName: encodeURIComponent(name) } }}
      className="underline-on-hover"
      style={style}
    >
      {value}
    </Link>
  );
};

export default decorate(UserTagCount);
